export const locale = {
  LANG_TEST: "The active language is: English",
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  GENERAL: {
    GENERAL_ERROR: "Something went wrong, please try again in a few minutes",
    FORM: {
      SUBMIT: "Submit"
    },
    MONTHS: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    MONTHS_SHORT: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ]
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    DASHBOARD: "Dashboard",
    SETTINGS: "Settings",
    SETTINGS_AFFILIATE: "Affiliate",
    SETTINGS_USER: "Account",
    SETTINGS_STORE: "Store",
    PUBLISHER: {
      SETTINGS_FINANCE: "Finance",
      SETTINGS_USER: "Account",
      SETTINGS_PUBLISHER: "Publisher",
      SETTINGS_INTEGRATIONS: "Integrations",
      SECTION_FINANCE: "Finance",
      FINANCE_PAYMENTS: "Payments",
      FINANCE_TRANSACTIONS: "Transactions",
      SECTION_ADVERTISERS: "Advertisers",
      MY_ADVERTISERS: "My Advertisers",
      ADVERTISERS_OVERVIEW: "Advertisers",
      ADVERTISER_DETAIL: "Advertiser",
      PRODUCTS: "Products",
      INVITE: "Invite Link"
    }
  },
  SIGNUP: {
    TITLE: "Sign Up",
    ALREADY_AN_ACCOUNT: "Already have an account?",
    LOG_IN: "Log in here",
    GENERAL_ERROR:
      "Something went wrong while signing up, please try again in a few minutes",
    LEFT: {
      TITLE: "Become a Project Cece publisher!",
      TEXT: "As a Project Cece publisher you have access to a curated collection of sustainable brands and products. Promote them on your platform and earn money while doing so!"
    },
    FORM: {
      USERTYPE: {
        LABEL: "I am a...",
        PLACEHOLDER: "Please select an option",
        PUBLISHER: "Publisher/Media",
        STORE: "Webshop/Brand",
        TOOLTIP:
          "Register as a webshop/brand if you sell sustainable products online. Register as Publisher/Media if you want to browse and promote sustainable products and brands."
      },
      NAME: {
        LABEL: "Name",
        REQUIRED: "Please enter your name",
        PLACEHOLDER: "Your name..."
      },
      EMAIL: {
        LABEL: "E-mail",
        REQUIRED: "Please enter an e-mail address",
        VALID: "Use a valid e-mail address"
      },
      PASSWORD: {
        LABEL: "Password",
        REPEAT_LABEL: "Repeat password",
        REQUIRED: "Please enter a password",
        MINLENGTH: "The password should be more than 5 characters",
        NOT_EQUAL: "The entered password are not equal"
      },
      TERMS: {
        LABEL: "I accept the {link}",
        LINK: "terms & conditions",
        REQUIRED: "Please read and agree with the terms & conditions"
      },
      BUTTON: "Sign up"
    }
  },
  LOG_IN: {
    FORM: {
      GENERAL_ERROR:
        "Something went wrong while logging in, please try again in a few minutes",
      EMAIL: {
        REQUIRED: "Please enter an e-mail address",
        VALID: "Use a valid e-mail address"
      },
      PASSWORD: {
        PLACEHOLDER: "Enter password...",
        REQUIRED: "Please enter a password"
      },
      BUTTON: "Log in"
    }
  },
  // auth/User.vue
  USER_SETTINGS: {
    FORM_LABELS: {
      COMPANY_NAME: "Company name:",
      LANGUAGE: "Invoice/notification language:",
      TAX_NUMBER: "Tax number:",
      ADDRESS_LINE1: "Invoice address line 1:",
      ADDRESS_LINE2: "Invoice address line 2:",
      INVOICING_EMAIL: "Email(s) for (proforma) invoices:",
      NOTIFICATION_EMAIL: "Email(s) for conversion notifications:",
      SALE_NOTIFICATION:
        "Receive an email notification when an order is made through Impactbytes or Project Cece",
      PAYMENT_TERM: "Payment term:",
      ACCOUNT_PASSWORD: "Account password",
      PUBLISHER_COMMISSION: "Publisher commission",
      IMPACTBYTES_COMMISSION: "Impactbytes commission",
      TOTAL_COMMISSION: "Total commission"
    },
    FORM_DESCRIPTIONS: {
      COMPANY_NAME:
        "The registered company that the invoices should be addressed too (note that this can be different than your store/brand name as displayed on the site.",
      PAYMENT_TERM:
        "Choose how often you want to receive invoices for commission sales if the commission threshold of €15 is reached (default is monthly invoicing).",
      CONFIRMATION_TYPE:
        "Choose how you would like to manage commission invoices. You can opt to review referral orders in concept invoices first for any returns before finalizing, or automate the process by directly receiving finalized commission invoices every payment term without indicating returns.",
      LANGUAGE:
        "This is the language used for communication, invoices etc. To change the language for the dashboard, use the dropdown in the top-right."
    },
    FORM_BLOCK_COMMISSION: {
      TITLE: "Default commission settings",
      INFO: "The publisher commission/attribution period you choose will be visible to publishers browsing the overview of merchants like you. Note that this does not affect the settings used for orders through Project Cece."
    },
    FORM_BLOCK_1: {
      TITLE: "Finance/Invoicing settings",
      DESCRIPTION:
        "Below you can find the details used for invoicing to your company. By changing and submitting the form, you can change the details used in future invoices."
    },
    FORM_BLOCK_2: {
      TITLE: "Email settings"
    },
    CHANGE_PASSWORD: "Change password",
    CHANGE_PASSWORD_LINK: "Click here to change password",
    SAVE_CHANGES: "Save changes",
    SUCCESS: "Your changes have been saved successfully!",
    ERROR: "Failed to load user data.",
    FORM_FIELDS: {
      PAYMENT_TERM: {
        MONTHLY: "Monthly",
        BI_MONTHLY: "Bi-Monthly",
        QUARTERLY: "Quarterly"
      }
    }
  },
  INVOICES: {
    DESCRIPTIONS: {
      VIEW_PDF: "Download PDF",
      PAY_INVOICE: "Pay invoice",
      NO_RESULTS: "There are no invoices for your store yet.",
      PAGE_TITLE: "Invoice Overview",
      PAGE_CAPTION:
        "An overview of the Impactbytes / Project Cece invoices for your store"
    },
    TYPES: {
      AFFILIATE: "Affiliate Sale",
      EXTRA: "Extra Exposure",
      SETUP: "Setup Fee",
      PLAN: "Impactbytes Plan",
      OTHER: "Other"
    },
    STATUS: {
      OPEN: "Open",
      CANCELLED: "Cancelled",
      AWAITING: "Awaiting payment receipt",
      PAID: "Payment received"
    },
    FIELDS: {
      INVOICE_ID: "Invoice ID",
      INVOICE_DATE: "Invoice date",
      TOTAL_AMOUNT: "Total amount",
      INVOICE_TYPE: "Invoice type",
      INVOICE_STATUS: "Status",
      ACTIONS: "Actions"
    },
    FIELD_DESCRIPTIONS: {
      INVOICE_ID: "The unique invoice identification number.",
      INVOICE_DATE:
        "The date the invoice was created and the payment term is counted from.",
      TOTAL_AMOUNT:
        "The total invoice amount to be paid (including tax if applicable).",
      INVOICE_TYPE:
        "The type of invoice (e.g., for sales commission, extra exposure or setup fee).",
      INVOICE_STATUS:
        "Indicates if the invoice has been paid or still requires payment (open).",
      ACTIONS: "Shows payment option if the invoice has not been paid yet."
    }
  },
  SALES_TABLE: {
    ALERTS: {
      NO_SALES_SELECTED: "Please select one or more sales!",
      PAYED_STATUS_UNCHANGEABLE:
        "The status of already paid sales can't be changed."
    },
    COLUMNS: {
      SELECT_ALL_TT: "Select all sales",
      ORDER_ID: "Order ID",
      ORDER_ID_TT: "Order ID field description",
      ORDER_DATE: "Order date",
      ORDER_DATE_TT: "Order date field description",
      PUBLISHER: "Referrer",
      PUBLISHER_TT:
        "The publisher through who the visitor came to your website",
      NETTO_TOTAL: "Net order total",
      NETTO_TOTAL_TT: "Net total field description",
      NETTO_COMMISSION: "Net commission",
      NETTO_COMMISSION_TT: "Net amount field description",
      PAYMENT_STATUS: "Payment status",
      PAYMENT_STATUS_TT: "Payment status field description",
      PARTIAL_RETURN: "Partial return amount (\u20AC)",
      PARTIAL_RETURN_TT: "Partial return amount field description",
      ACTIONS: "Actions",
      ACTIONS_TT: "Actions field description",
      INVOICE: "Invoice",
      INVOICE_TT: "Invoice field description"
    },
    ROWS: {
      PAYMENT_STATUSES: {
        PICK_STATUS: "Pick a status",
        OPEN: "Open",
        TBI: "Confirmed",
        CANCELED: "Cancelled",
        PAYED: "Paid",
        UNKNOWN: "Unknown"
      },
      PARTIAL_RETURN_AMOUNT: "Partial return amount",
      RETURN_TEXT: "After net returned:",
      NOT_AVAILABLE: "N/A",
      INVOICE_BUTTONS: {
        VIEW_INVOICE: "Download Invoice",
        PAY_INVOICE: "Pay Invoice",
        CONCEPT_INVOICE: "Check Concept Invoice"
      }
    },
    FILTERS: {
      ORDER_ID: "Order ID",
      DATE_FROM: "From",
      DATE_TO: "To",
      STATUS: "Payment status",
      CLEAR_FILTER: "Clear filter"
    },
    ACTIONS: {
      SELECT_ACTION: "Select an action",
      CREATE_INVOICE: "Create invoice for selected sale(s)",
      CONFIRM_SELECTED_SALES: "Confirm selected sale(s)",
      CONFIRM_SELECTED_SALES_AND_PAY: "Confirm selected sale(s) and pay",
      CANCEL_SELECTED_SALES: "Cancel selected sale(s)"
    },
    MINI_UI: {
      EDIT: "Edit",
      EDIT_TT: "Confirm or cancel sale or update totals if partially returned",
      DETAILS: "Details",
      DETAILS_TT: "View sale details"
    },
    CAPTION: "An overview of sales through Impactbytes / Project Cece",
    RESULTS: "results",
    TOTAL: "total",
    FILTER: "Filter sales",
    CLEAR_FILTER: "Clear filters",
    ACTION: "Action",
    RUN: "Run",
    LOADING: "Loading",
    ACTIVE_FILTERS: "Active filters:",
    NO_RESULTS:
      "There have not been any sales through Impactbytes / Project Cece yet.",
    NO_SEARCH_RESULTS: "No sales were found matching the filter criteria...",
    AUTO_GENERATED_ORDER_ID_EXPLANATION:
      "This order has an auto-generated order ID as we did not receive the Order ID from your webshop when the order was created. If you are using Shopify, this is due to the fact that they do delayed order processing when their servers are bussy, meaning that the order ID does not exist yet when the order is created. Please use the order datetime + value (or products for the latest affiliate version) to find it in your systems."
  },
  SALES_TABLE_FILTER: {
    TITLE: "Filter Sales",
    CAPTION: "Choose one or more filters below to make a selection.",
    OK: "Apply filters",
    FIELDS: {
      ORDER_ID: {
        LABEL: "Filter by order ID",
        PLACEHOLDER: "e.g, ORD10000"
      },
      PERIOD: {
        LABEL: "Filter by period",
        MONTH: "Month",
        YEAR: "Year",
        SELECT_YEAR_WARNING: "Please select a year",
        END_TOO_EARLY_WARNING: "Please select an end date after the start date",
        DATE_RANGE_LINK: "Or select a custom date range",
        SIMPLE_DATE_LINK: "Or select a month and year",
        MONTH_OPTIONS: {
          PICK_MONTH: "Pick a month",
          JAN: "January",
          FEB: "February",
          MAR: "March",
          APR: "April",
          MAY: "May",
          JUN: "June",
          JUL: "July",
          AUG: "August",
          SEP: "September",
          OCT: "October",
          NOV: "November",
          DEC: "December"
        },
        YEAR_OPTIONS: {
          PICK_YEAR: "Pick a year"
        },
        FROM: "From",
        TO: "To"
      },
      STATUS: {
        TITLE: "Filter by order status",
        LABEL: "Payment Status"
      }
    }
  },
  PARTIAL_RETURN_MODAL: {
    TITLE: "Partial Return Modal",
    CAPTION: "Make a selection to filter sales data."
  },
  EDIT_SALE_MODAL: {
    TITLE: "Edit order",
    CAPTION: "Edit a specific order.",
    INTRO:
      "Here you can update the status for this order. TIP: Do you want to update multiple sales at once? You can select multiple sales and choose an update action at the top of the sales table!",
    SELECT_MODE_CAPTION: "What would you like to do?",
    MODES: {
      CONFIRM_SALE: {
        OPTION_NAME: "Confirm this sale!",
        SUCCESS: "This sale has been confirmed successfully.",
        ERROR: "Something went wrong while confirming this sale."
      },
      CANCEL_SALE: {
        OPTION_NAME: "Cancel order (if it was completely returned)",
        SUCCESS: "This order has been canceled successfully.",
        ERROR: "Something went wrong while canceling this order."
      },
      RETURN_SALE: {
        OPTION_NAME:
          "Indicate returned amount for order (if it was partially returned)",
        OPTION_DESCR:
          "Enter the amount that was returned below. You can enter the amount either with or without 21% tax and the new net order total will be calculated.",
        SUCCESS: "This sale's returned amount has been set successfully.",
        ERROR:
          "Something went wrong while setting the returned amount for this sale."
      }
    }
  },
  DETAIL_SALE_MODAL: {
    TITLE: "Order Details",
    CAPTION: "View a specific sale.",
    TABLES: {
      NOT_AVAILABLE: "N/A",
      GENERAL: {
        TITLE: "General information",
        ORDER_ID: "Order ID",
        DATE_TIME: "Order date",
        CECE_COUNTRY: "Referrer"
      },
      TOTALS: {
        TITLE: "Totals information",
        SUBTOTAL: "Subtotal (net)",
        RETURNED_NETTO: "Returned amount (net)",
        COMMISSION_NETTO: "Commission (net)",
        COMMISSION_PERCENTAGE: "Commission percentage"
      },
      STATUS: {
        TITLE: "Status information",
        ORDER_STATUS: "Order status",
        INVOICE: "Invoice",
        PROFORMA_INVOICE: "Proforma invoice"
      },
      CURRENCY: {
        TITLE: "Currency information",
        ORIGINAL_CURRENCY: "Original currency",
        EXCHANGE_RATE: "Used exchange rate"
      },
      EXTRA_INFO: {
        TITLE: "Extra info",
        ALTERNATIVE_ID: "Alternative ID"
      }
    }
  },
  CONFIRM_SALES_MODAL: {
    TITLE: "Confirm Sales",
    CAPTION:
      "Are you sure that you want to confirm that these sales are correct and their commission can be invoiced?",
    OK_TITLE: "Confirm"
  },
  CANCEL_SALES_MODAL: {
    TITLE: "Cancel Sales",
    CAPTION: "Are you sure that you want to cancel these sales?",
    OK_TITLE: "Confirm"
  },
  CONFIRM_SALES_AND_PAY_MODAL: {
    TITLE: "Confirm Sales and Pay",
    CAPTION:
      "Are you sure that you want to confirm that these sales are correct and pay them?",
    OK_TITLE: "Confirm and Pay"
  },
  PAGINATION: {
    FIRST: "First",
    PREVIOUS: "Prev",
    NEXT: "Next",
    LAST: "Last",
    TOTAL_PAGES: "Total number of pages"
  },
  RETURN_AMOUNT_VIEW: {
    NETTO_TOTAL: "Net total",
    NETTO_TOTAL_TT: "The order net total in EUR that the commission is calculated on",
    NETTO_COMMISSION: "Net commission",
    NETTO_COMMISSION_TT: "The net commission amount in EUR",
    NETTO_RETURNED: "Net returned",
    NETTO_RETURNED_TT: "The net amount that was returned for each order",
    RETURN_AMOUNT: "Return amount",
    INCL_VAT: "Including BTW (21%)",
    CALCULATE: "Calculate",
    CONFIRM: "Confirm return",
    RETURN_AMOUNT_PLACEHOLDER: "Enter a return amount",
    ILLEGAL_VALUE: "Value not allowed"
  },
  PAYMENT_WIZARD: {
    FETCH_FAILED:
      "Failed to get proforma data. Are you sure the proforma ID exists?",
    CONFIRM_SALES: "Confirm selected sales",
    CONFIRM_ALL_SALES: "Confirm all sales",
    NO_RESULTS:
      "There are no sales for this proforma, so no need to do anything here! Did you close this proforma already?",
    STEPS: {
      STEP_1: {
        TITLE: "Edit sales",
        DESCRIPTION:
          "Below you can find a list of all the sales for the current concept invoice and indicate if any orders were (partially) returned."
      },
      STEP_2: {
        TITLE: "Review invoice",
        DESCRIPTION:
          "Please review the concept invoice for these affiliate sales. Any returns? Click the button to go to the previous step to edit the sales. <br><br><b>After confirming this concept invoice, a payment invoice will be created and changes to the invoice are no longer possible.</b>",
        SUBTOTAL: "Subtotal",
        VAT: "VAT",
        TOTAL: "Total",
        DATA_MISSING: "Failed to retrieve proforma data from the backend."
      },
      STEP_3: {
        TITLE: "Make payment",
        TITLE_FULL: "Payment for Invoice",
        DESCRIPTION:
          "Below you can find the details for your invoice and choose a payment option.",
        NO_INVOICE:
          "Oops... No invoice was found for this proforma. Please go to step 2 and try confirming again.",
        INVOICE: "Invoice",
        DETAILS: {
          FULL_ID: "Full invoice ID",
          INVOICE_DATE: "Invoice date",
          STATUS: "Status",
          SALES_PERIOD: "Sales period",
          SUBTOTAL: "Subtotal",
          TOTAL: "Total",
          BTW: "BTW"
        },
        PAYMENT_OPTIONS: {
          OPTION: "Option",
          IDEAL: {
            TITLE: "Pay online",
            DESCRIPTION:
              "Pay online easily using iDeal, Credit card, Debit card, Bancontact or Sofort. You will be redirected to the payment portal to make a secure payment and will arrive back here after you are done. ",
            LINK_NAME: "Go to online payment",
            UNAVAILABLE: "Sorry, online payment is not available at this time."
          },
          MANUAL: {
            TITLE: "Manual transfer",
            DESCRIPTION:
              "If you prefer, you can also pay by manually transferring the amount to our bank account. Just make sure to quote the invoice ID in the payment description.",
            IBAN: "NL71BUNQ2031925687",
            COMPANY: "Project Cece",
            REFERENCE: "Invoice ID to reference",
            BIC_SWIFT: "BUNQNL2A"
          }
        }
      }
    },
    PREVIOUS: "Previous",
    NEXT: "Next Step",
    CONFIRM_AND_PAY: `Confirm and pay <br/><small>No edits to the invoice are possible after this</small>`,
    GO_TO_THREE: `Next Step <br/><small>The proforma has already been confirmed</small>`,
    CLOSE_WIZARD: "Close payment wizard",
    INDICATE_ALL_STATUSES:
      "Indicate the status of all sales to go to the next step! I.e., indicate if they are (partially) returned or confirmed.",
    THRESHOLD: {
      MESSAGE:
        "The total amount of these sales is now less than the threshold amount of €15. Would you like to move these sales to the next payment term?",
      CLOSE_AND_MOVE: "Close proforma & move open sales to next payment term",
      SUCCESS: "Open sales have been moved to next payment term!",
      ERROR: "Failed to move open sales to the next payment term."
    }
  },
  PAYMENT_SUCCESS: {
    CHECKING_PAYMENT_STATUS: "Checking payment status",
    PAYMENT_STATUS_SUCCESS:
      "Thank you, you are all set! We have received your payment",
    PAYMENT_STATUS_WARNING:
      "Thanks for making the payment! It may take a few minutes for the amount to arrive on our bank account.",
    PAGE_LOAD_ERROR: "Oops... Something went wrong while loading this page."
  },
  PROFORMA_ACTION_TABLE: {
    TITLE: "Proforma actions",
    DESCRIPTION:
      "Your action is required for these concept invoices (proforma invoices).",
    COLUMNS: {
      ID: "Proforma ID",
      ID_TT: "Proforma ID description",
      DESCRIPTION: "Description",
      DESCRIPTION_TT: "Proforma description",
      TOTAL: "Total",
      TOTAL_TT: "Proforma total",
      ACTION: "Action",
      ACTION_TT: "Actions to take for each proforma"
    },
    ACTIONS: {
      CHECK_AND_PAY: "Check and pay"
    },
    VIEW_ALL: "View all concept invoices",
    MORE_PROFORMA: "You have one more concept invoice",
    MORE_PROFORMAS: "You have {n} more concept invoices to check"
  },
  INVOICE_CONFIRMED: {
    MESSAGE:
      "Thanks for confirming the sales. An invoice with payment details has now been sent to your email address.",
    TO_DASHBOARD: "Visit the dashboard"
  },
  SIMPLE_STATS_ROW: {
    TOTAL_NUMBER_SALES: {
      TITLE: "Number of sales",
      DESCRIPTION: "Total number of sales through Impactbytes / Project Cece"
    },
    TOTAL_AMOUNT_SALES: {
      TITLE: "Net total all orders",
      DESCRIPTION:
        "Total net order amount of sales through Impactbytes / Project Cece"
    },
    OPEN_INVOICES: {
      TITLE: "Open invoices",
      DESCRIPTION: "Total number of open invoices awaiting payment"
    },
    OPEN_PROFORMAS: {
      TITLE: "Open proforma concept invoices",
      DESCRIPTION: "Proforma concept invoices that need to be checked"
    }
  },
  NEWS_FEED: {
    INFORMATION_KIT: "Information Kit",
    STATIC_WELCOME: {
      TITLE: "Welcome to the Project Cece partner dashboard!",
      DESCRIPTION:
        "We are very glad to introduce this dashboard to you, which will make our collaboration work even smoother! The Finance section of the dashboard will allow you to at any time view all your sales, invoices and concept invoices to check for and indicate returns/cancellations.",
      DESCRIPTION_P2:
        "At the moment, the Finance section of the dashboard is ready for use! The dashboard will be expanded with Analytics/Insights and options to get extra exposure. We would love to hear from you if you have any feedback. - The Project Cece Team"
    },
    NEWS_SINGLE: {
      TITLE: "News"
    },
    NEWS_FEED: {
      TITLE: "News Feed"
    }
  },
  FAVOURITE_PRODUCTS_TABLE: {
    TITLE: "Top saved products by Cece users",
    DESCRIPTION:
      " Our users' current top favourited {storeName} products per Cece site.",
    COLUMNS: {
      INDEX: "#",
      INDEX_TT:
        "The product's ranking based on how many times it's saved by users",
      NAME: "Product name",
      NAME_TT: "The product's name as displayed on Project Cece",
      SECTION: "Section",
      SECTION_TT:
        "The Project Cece section the saved product was viewed in (Women/Men/Kids)"
    }
  },
  PAGE_TITLES: {
    PARTNERS: "Partners",
    SETTINGS: "Settings",
    USER_SETTINGS: "User Settings",
    AFFILIATE_SETTINGS: "Affiliate Settings",
    STORE_SETTINGS: "Store Settings",
    SALES: "Sales Overview",
    INVOICES: "Invoices Overview",
    INVOICE_WIZARD: "Invoice Payment",
    PAYMENT_SUCCESS: "Thanks for paying!",
    LOGIN: "Login",
    SIGNUP: "Sign up",
    PW_RESET: "Reset password",
    PW_CHANGE: "Change password",
    E404: "Page not found",
    FFGC_TRANSACTIONS: "Transactions",
    FFGC_PAYMENTS: "Payments",
    STORE: "Store",
    SHIPPING_ZONES: "Shipping zones",
    WEBSHOP_MY_PUBLISHERS: "My Publishers",
    WEBSHOP_PUBLISHERS: "Publishers",
    WEBSHOP_PUBLISHER: "Publisher",
    WEBSHOP_DATA_FEEDS: "Data feeds",
    STORE_TERMS_AND_CONDITIONS: "Terms & Conditions",
    STORE_SETTINGS_UPGRADE: "Upgrade plan",
    PUBLISHER_FINANCE_SETTINGS: "Finance settings",
    PUBLISHER_USER_SETTINGS: "Account settings",
    PUBLISHER_CONFIRM_EMAIL: "Confirm e-mail",
    PUBLISHER_ADVERTISERS_OVERVIEW: "Advertisers",
    PUBLISHER_TERMS_AND_CONDITIONS: "Terms & Conditions",
    PUBLISHER_FINANCE_PAYMENTS: "Payments"
  },
  QUICK_USER: {
    NOTIFICATIONS: {
      PROFORMAS_CTA: "Action required",
      PROFORMAS: "Check concept invoice | {n} concept invoices to check",
      INVOICES:
        "Awaiting payment for 1 open invoice | Awaiting payment for {n} open invoices",
      CONFIRM_EMAIL: "Confirm your e-mail address",
      CONFIRM_EMAIL_SUBTITLE: "You received a confirmation e-mail on {email}",
      PLACEHOLDER:
        "You are all set! If there are any open (concept)invoices for your store, they will be displayed here.",
      PLACEHOLDER_PUBLISHER: "No new notifications"
    },
    ACCOUNT_SETTINGS: "Account settings"
  },
  PASSWORD_RESET: {
    HEADER: {
      KNOW_YOUR_PASSWORD: "Know your password",
      SIGN_IN: "Sign In"
    },
    ALERTS: {
      NO_ACCOUNT_FOR_EMAIL: "No account could be found for this email address",
      EMAIL_SENT: "A password reset link has been sent to:",
      GENERIC_ERROR: "Something went wrong while processing your request."
    },
    TITLE: "Reset password",
    DESCRIPTION:
      "Enter the email address related to your account to receive a password reset link.",
    FORM: {
      FIELDS: {
        EMAIL: {
          PLACEHOLDER: "Email address",
          ERROR: "Email is required and a valid email address."
        }
      },
      SUBMIT: "Send password reset link",
      SUBMIT_PW: "Save password",
      CANCEL: "Cancel"
    }
  },
  PASSWORD_RESET_FORM: {
    HEADER: {
      KNOW_YOUR_PASSWORD: "Know your password",
      SIGN_IN: "Sign In"
    },
    TITLE: "Reset Password",
    DESCRIPTION: "Enter your preferred new password twice to reset it.",
    FORM: {
      FIELDS: {
        PW_1: {
          PLACEHOLDER: "Your new password",
          ERROR: "This field is required!",
          INVALID: "Password is invalid."
        },
        PW_2: {
          PLACEHOLDER: "Verify your new password",
          ERROR: "This field is required!",
          INVALID: "Passwords do not match."
        }
      },
      SUBMIT: "Reset password",
      CANCEL: "Cancel"
    },
    STATES: {
      VALIDATING_TOKENS: "Validating tokens...",
      INVALID_TOKENS: "This url is invalid. Did you already use it before?",
      API_ERROR: "An API error occurred."
    },
    SUCCESS_P: "Password has been set successfully.",
    ERROR_P: "Something went wrong while trying to reset your password.",
    ERRORS_HEADER: "The following errors occurred"
  },
  CHANGE_PASSWORD: {
    TITLE: "Change password",
    DESCRIPTION:
      "Enter you current password, your new password and confirm your new password.",
    YOUR_EMAIL: "Your account email address:",
    FORM: {
      EMAIL: {
        PLACEHOLDER: "Your email"
      },
      CURRENT_PW: {
        PLACEHOLDER: "Your current password",
        INVALID: "Please enter your current password"
      },
      NEW_PW: {
        PLACEHOLDER: "Your new password",
        INVALID: "Please enter a valid password"
      },
      REPEAT_NEW_PW: {
        PLACEHOLDER: "Repeat your new password",
        INVALID: "This password does not match"
      }
    },
    SUCCESS: "Your password has been changed.",
    SUCCESS_P: "Successfully updated your password!",
    ERROR: "Failed to change password.",
    ERROR_P: "Failed to change password.",
    ERRORS_HEADER: "We ran into the following errors",
    EMAIL_FETCH_ERROR: "Failed to get the user email address."
  },
  ACCOUNT_SETTINGS: {
    TITLE: "User account settings",
    DESCRIPTION: "Update your personal user account's settings.",
    SUCCESS: "Your changes have been saved successfully!",
    ERROR: "Failed to load user data.",
    ERROR_SAVE: "Failed to save your changes.",
    FORM_LABELS: {
      FIRST_NAME: "First name",
      LAST_NAME: "Last name",
      ACCOUNT_PASSWORD: "Account password"
    },
    SAVE_CHANGES: "Save changes",
    UNSAVED_CHANGES_MSG:
      "Do you really want to leave? you have unsaved changes!",
    CHANGE_PASSWORD_LINK: "Click here to change password"
  },
  TRANSACTIONS_TABLE: {
    COLUMNS: {
      SELECT_ALL_TT: "Select all transactions",
      ORDER_ID: "Order ID",
      ORDER_ID_TT: "Order ID field description",
      ORDER_DATE: "Date",
      ORDER_DATE_TT: "Order date field description",
      GIFTCARD_CHARGED: "Giftcard charged",
      GIFTCARD_CHARGED_TT: "Total amount paid with giftcard",
      NETTO_TOTAL: "Net fee Project Cece",
      NETTO_TOTAL_TT: "Net commission fee for Project Cece",
      PAYMENT_STATUS: "Payment status",
      PAYMENT_STATUS_TT:
        "Status of outpayment to your account from Project Cece",
      PAYMENT_DATE: "Payment date",
      PAYMENT_DATE_TT: "Date of outpayment to your account",
      CREDIT_NOTE_ID: "Credit note ID",
      CREDIT_NOTE_ID_TT:
        "Credit note invoice of the Fair Fashion Giftcard transactions"
    },
    ROWS: {
      PAYMENT_STATUSES: {
        PAID: "Paid",
        PENDING: "Payment pending"
      }
    },
    CAPTION:
      "An overview of Fair Fashion Gift Card transactions through Project Cece",
    RESULTS: "results",
    TOTAL: "total",
    LOADING: "Loading",
    NO_RESULTS: "There have not been any sales through Project Cece yet."
  },
  PAYMENTS_TABLE: {
    COLUMNS: {
      SELECT_ALL_TT: "Select all payments",
      CREDIT_NOTE_ID: "Credit note ID",
      CREDIT_NOTE_ID_TT: "Identification number of credit note invoice",
      CREDIT_NOTE_DATE: "Credit note date",
      CREDIT_NOTE_DATE_TT: "Date of credit note invoice",
      DESC: "Description",
      DESC_TT: "Payment description",
      TTT: "Total transfer amount",
      TTT_TT: "Total amount paid",
      PAYMENT_DATE: "Payment date",
      PAYMENT_DATE_TT:
        "Date payment has been transferred from our bank account",
      PAYMENT_STATUS: "Payment status",
      PAYMENT_STATUS_TT: "Status of credit note payment",
      PDF: "Credit note PDF",
      PDF_TT: "Download the credit note PDF"
    },
    ROWS: {
      PAYMENT_STATUSES: {
        PAID: "Paid",
        PENDING: "Pending"
      }
    },
    DOWNLOAD: "Download PDF",
    CAPTION:
      "An overview of Fair Fashion Gift Card transactions through Project Cece",
    RESULTS: "results",
    TOTAL: "total",
    LOADING: "Loading",
    NO_RESULTS: "There have not been any sales through Project Cece yet."
  },
  MEMBERSHIP: {
    TIERS: {
      BASIC: "Basic",
      PREMIUM: "Unlimited",
      PLATINUM: "Growth"
    },
    ACCOUNT: "account",
    PROJECT_CECE: "Project Cece / Impactbytes",
    NOT_FOUND: "Project Cece / Impactbytes affiliate"
  },
  SHIPPING_ZONES: {
    TITLE: "Shipping zones",
    CAPTION:
      "Below you can find, add and edit your store's shipping rates as shown to Project Cece / Impactbytes users. " +
      "As the Project Cece platform is available in multiple countries, the countries you select in the shipping zones " +
      "below will determine to which users from different locations your products will be shown. The shipping zone " +
      "rates can be shown to users as an indication/estimate.",
    TABLE: {
      COLUMNS: {
        NAME: "Name",
        NAME_TT:
          "Name for the shipping zone (e.g, Domestic, EU, Rest of World). This will not be shown to users but is for your own reference.",
        PRICE: "Price (€)",
        PRICE_TT: "Default shipping cost for this zone (€)",
        FREE_FROM: "Free from (€)",
        FREE_FROM_TT:
          "Shipping costs are free for this zone from this checkout price (€)"
      },
      ROWS: {
        EDIT: {
          BTN: "Edit"
        }
      },
      FREE_FROM_NA: "Not applicable",
      ADD_SHIPPING_ZONE_BTN: "Add another shipping zone"
    }
  },
  SHIPPING_ZONES_MODAL: {
    ADD: {
      TITLE: "Create new shipping zone",
      SUBMIT: "Create"
    },
    EDIT: {
      TITLE: "Edit shipping zone",
      SUBMIT: "Save"
    },
    DELETE: {
      BTN: "Delete",
      CONFIRM: "Are you sure you want to delete this shipping zone?"
    },
    FORM: {
      NAME: {
        LABEL: "Name",
        DESCRIPTION:
          "Name for the shipping zone (e.g, Domestic, EU, Rest of World).",
        INVALID: "The shipping zone's name cannot remain empty."
      },
      DEFAULT_PRICE: {
        LABEL: "Price (€)",
        DESCRIPTION: "Default shipping cost for this zone in Euro (€)",
        INVALID: "The shipping rate cannot remain empty."
      },
      HAS_FREE_SHIPPING: {
        LABEL: "Shipping in this zone is free from a certain checkout price."
      },
      FREE_FROM: {
        LABEL: "Free shipping starting at (€)",
        DESCRIPTION:
          "Shipping costs are free for this zone from this checkout price in Euro (€)",
        INVALID:
          "An empty field is not allowed here. Uncheck the checkbox if no free shipping is available for this zone."
      },
      ZONE_COUNTRIES: {
        LABEL: "Countries in this zone",
        DESCRIPTION: "Select all countries that fall under this shipping zone.",
        PLACEHOLDER: "Select one or more countries",
        INVALID: "Please select at least one country",
        BTN_DESELECT_ALL: "Deselect all countries"
      }
    },
    ERROR_MESSAGES: {
      DUPLICATE_COUNTRIES_SHIPPING_ZONE:
        "Unable to add countries to zone if they are already part of another shipping zone. Are you sure you want to add them here?",
      SINGULAR_DUPLICATE: "Duplicate country",
      PLURAL_DUPLICATE: "Duplicate countries"
    }
  },
  STORE_SETTINGS: {
    TITLE: "Store settings",
    SUCCESS: "Your changes have been saved successfully!"
  },
  SITE_STATS: {
    TITLE: "Quick overview",
    TABLE: {
      COLUMNS: {
        COUNTRY: "Country",
        TOTAL_PRODUCTS: "# Products online",
        LAST_UPDATED: "Products last updated",
        VISIT_STORE: "Link"
      },
      LAST_UPDATED: "Your products were last updated on %{datetime}",
      TIME_DELTA: {
        LESS_THAN_ONE_HOUR: "Updated less than one hour ago",
        DAY_SINGULAR: "day",
        DAY_PLURAL: "days",
        HOUR_SINGULAR: "hour",
        HOUR_PLURAL: "hours",
        MONTH_SINGULAR: "month",
        MONTH_PLURAL: "months",
        YEAR_SINGULAR: "year",
        YEAR_PLURAL: "years",
        AGO: "ago",
        AND: "and"
      }
    }
  },
  STATISTICS: {
    SALES: "Sales",
    SERIES_LABELS: {
      NUMBER_OF_ORDERS: "Number of orders",
      SALES_REVENUE: "Sales revenue"
    },
    MONTHLY_SALES: {
      TITLE: "Monthly sales",
      SUB_TITLE: "Your sales per month for %{year}.",
      CURRENT_YEAR: "the current year",
      TOTAL_TT: "Total number of sales"
    },
    MONTHLY_REVENUE: {
      TITLE: "Monthly revenue",
      SUB_TITLE: "Your revenue per month for %{year}.",
      CURRENT_YEAR: "the current year",
      TOTAL_TT: "Total number of sales"
    },
    COMBINED_GRAPH: {
      TITLE: "Monthly sales and revenue",
      SUB_TITLE:
        "The number of sales and revenue through Impactbytes / Project Cece per month for %{year}.",
      CURRENT_YEAR: "the current year",
      TOTAL_TT: "Total number of sales"
    }
  },
  EMAIL_CONFIRMATION: {
    TITLE: "E-mail confirmation",
    TEXT_LOADING: "We're confirming your e-mail address...",
    TEXT_SUCCESS: "Your e-mail address is confirmed! 🙌",
    TEXT_ERROR:
      "Someting went wrong while confirming your e-mail, try again in a few moments, or {link}.",
    RESEND_LINK: "re-send the confirmation e-mail"
  },
  EMAIL_CONFIRMATION_SETTINGS: {
    TITLE: "E-mail confirmation",
    TEXT: "You're e-mail address is not confirmed yet. Use the button in the confirmation e-mail we send to {email} to confirm your e-mail address, or use the button below to resend a confirmation e-mail.",
    BUTTON: "Re-send confirmation e-mail",
    ERROR:
      "Something went wrong while resending a confirmation e-mail, please try again in a few moments. If the problems persists reach out to us at {email}.",
    SUCCESS: "A confirmation e-mail has been sent to {email}!"
  },
  PUBLISHER_DASHBOARD: {
    PAGE_TITLE: "Dashboard",
    CLICKS_MONTH: {
      TITLE: "Clicks this month",
      DESCRIPTION: "Total number of clicks on affiliate links promoted by you"
    },
    SALES_MONTH: {
      TITLE: "Sales this month",
      DESCRIPTION: "Total number of affiliate sales"
    },
    COMMISSION_MONTH: {
      TITLE: "Commission this month",
      DESCRIPTION: "Total amount of earned commission this month"
    },
    COMMISSION_TOTAL: {
      TITLE: "Total commission",
      DESCRIPTION: "Total amount of earned commission"
    },
    TRANSACTIONS: {
      TITLE: "Recent transactions",
      NO_RESULTS:
        "Here you'll see the most recent transaction from your advertiser. Get started by connecting with {link}.",
      NO_RESULTS_LINK: "advertisers"
    }
  },
  PUBLISHER_MY_ADVERTISERS: {
    PAGE_TITLE: "My Advertisers",
    TITLE: "My Advertisers",
    INTRO:
      "With the below advertisers (i.e., online brands and retailers) you either have a pending or active request to work together. For any advertiser that you have an active collaboration with below, you can immediately start to use their affiliate links on your platform(s) to earn commissions. Sales from referrals will be tracked automatically."
  },
  PUBLISHER_INVITE_LINK: {
    PAGE_TITLE: "Invite Link"
  },
  PUBLISHER_ADVERTISERS_OVERVIEW: {
    PAGE_TITLE: "Advertisers",
    TITLE: "Advertisers",
    TEXT: "This overview shows all advertisers (i.e., online brands and retailers) available on Impactbytes. Find advertisers that fit your values and apply to their affiliate offer to start working together.",
    LABELS_TOOLTIP:
      "Sustainability labels, these indicate different aspects of sustainability",
    SEARCH_PLACEHOLDER: "Enter search query...",
    INVITE_TEXT: "Would you like to work with a brand/shop that is not yet on Impactbytes for an affiliate collaboration? {link}",
    INVITE_TEXT_LINK: "Invite them to join your affiliate brands for free!",
    TRACKING_STATUS_TOOLTIP: "Indicates whether the affiliate tracking code is active on the advertiser's website. This is required to track sales and earn commissions and should always be the case. The tracking status is checked regularly for interruptions.",
    PAYMENT_TERM_TOOLTIP: "The payment term indicates at what interval the advertiser has chosen to confirm and pay out commissions.",
    ATTRIBUTION_PERIOD_TOOLTIP: "The attribution period is the time period in which a customer can make a purchase after clicking on your affiliate links and you will still receive commission for it. The longer the attribution period, the more likely you are to receive commission for a purchase.<br><br><em>This value can be adjusted by the store.</em>",
    COMMISSION_TOOLTIP: "The commission percentage you receive of each of order placed by a customer referred through your affiliate link(s) within the attribution period. <br><br><em>This value can be adjusted by the store.</em>",
    BONUS_TOOLTIP: "This icon indicates that you invited this partner through your unique invite link.<br><br> If the partner upgrades to a paid plan, you will receive 15% of their plan payments for as long as they are on the paid plan. This reward is specific to partners who join and upgrade via your unique invite link."
  },
  PUBLISHER_ADVERTISER_DETAIL: {
    PAGE_TITLE: "Advertiser",
    AFFILIATE_LINK_TOOLTIP:
      "Browse {store_name} to find a page you would like to link to, paste the link in the destination field, and use the 'generate link' button to get an affiliate link to that page.",
    NOT_FOUND_ERROR: "Advertiser not found",
    NOT_FOUND_ERROR_TEXT:
      "We couldn't find this advertiser, please try again later or browse for another advertiser on the advertiser overview page",
    FETCH_ERROR: "Error fetching advertiser"
  },
  PUBLISHER_TRANSACTIONS: {
    PAGE_TITLE: "Transactions",
    TITLE: "Transactions",
    STATUS_pending: "Pending",
    STATUS_confirmed: "Confirmed",
    STATUS_cancelled: "Cancelled",
    STATUS_paid: "Paid"
  },
  DEAL_STATUS: {
    SHORT: {
      pending: "pending",
      active: "active",
      rejected: "rejected",
      expired: "expired"
    },
    LONG: {
      pending: "request pending",
      active: "active",
      rejected: "rejected",
      expired: "expired",
      sent: "request sent",
      received: "request received",
      none: "no status"
    }
  },
  WEBSHOP_DATA_FEEDS: {
    TITLE: "Data Feeds",
    TEXT: "You can use the Product Data Feeds that we create for you, to easily integrate your products with other partners such as search engines or shopping tools. This way they can always use and promote your up-to-date product information to reach an even larger audience.",
    COMING_SOON:
      "We're adding new features every day! Product Data feeds will soon be available for everyone on the Standard or Growth plan.",
    PRO_REQUIRED:
      "Data feeds are only available for stores with a Standard or Growth plan."
  },
  PRO_BANNER: {
    MORE_INFORMATION: "For more information contact {email}"
  },
  DEAL_FLOW: {
    PUBLISHER: {
      ACCOUNT_APPROVAL_WARNING:
        "Sorry! Your account hasn't been approved yet, it should be reviewed within a day. Waiting for a longer time? Reach out to us at info@impactbytes.io.",
      REQUEST: {
        CONFIRM_EMAIL_WARNING:
          "Confirm your e-mail address before sending a collaboration request to advertisers"
      },
      RESPOND: {
        CONFIRM_EMAIL_WARNING:
          "Confirm your e-mail address before replying to a collaboration request"
      },
      COMMISSION_TOOLTIP:
        "The commission percentage you receive of each of order placed by a customer who enters {store_name} through your affiliate link within the attribution period. <br><br><em>This value can be adjusted by the store.</em>"
    },
    STORE: {
      REQUEST: {
        UPGRADE_WARNING:
          "There is no more space for new collaborations in your current plan",
        UPGRADE_TOOLTIP:
          "Your current plan allows one pending or active collaboration. End one of your current collaborations or upgrade to a premium plan.",
        UPGRADE_AFFILIATE_VERSION_WARNING:
          "To start a collaboration, please first install the latest version of the affiliate tracking code."
      },
      RESPOND: {
        UPGRADE_AFFILIATE_VERSION_WARNING:
          "To respond to this collaboration request, please first install the latest version of the affiliate tracking code."
      }
    }
  },
  CONTACT: {
    PAGE_TITLE: "Contact"
  },
  WEBSHOP: {
    ONBOARDING: {
      PAGE_TITLE: "Onboarding",
      FORM: {
        SUBMIT: "Submit",
        STORE_NAME: {
          LABEL: "(Web)shop name",
          REQUIRED: "Please enter the name of your store/webshop"
        },
        LOGO: {
          LABEL: "Logo"
        },
        COMPANY_EMAIL: {
          LABEL: "Company e-mail (for notifications and invoices)",
          REQUIRED: "Please enter your company e-mail address"
        },
        LINK: {
          LABEL: "Website link",
          TOOLTIP:
            "A valid url looks like: exampe.com, www.exampe.com, https://example.com, example.com/about",
          REQUIRED:
            "Enter a link to your (company) website or one of your social accounts",
          VALID: "Enter a valid url"
        },
        STORE_TYPE: {
          LABEL: "Store type",
          TOOLTIP:
            "Let us know if your (web)shop has products from a single brand or from multiple brands",
          REQUIRED:
            "Select if your store has products from a single brand, or multiple brands"
        },
        ECOMMERCE_FRAMEWORK: {
          LABEL: "E-commerce framework",
          REQUIRED: "Select an e-commerce framework"
        },
        ECOMMERCE_OTHER: {
          LABEL: "Name of e-commerce framework"
        }
      }
    },
    ANALYTICS: {
      PAGE_TITLE: "Analytics"
    },
    PUBLISHER_OVERVIEW: {
      TITLE: "Publishers",
      TEXT: "Looking for new ways to promote your store, brand or products? Browse the overview below to find a publisher fitting your criteria.",
      INVITE_TEXT:
        "Would you like to invite a publisher that is not yet on Impactbytes for a collaboration? {link}",
      INVITE_TEXT_LINK: "Invite them to your affiliate program!"
    },
    PUBLISHER_DETAIL: {
      NOT_FOUND_ERROR: "Publisher Not Found",
      NOT_FOUND_ERROR_TEXT:
        "Data for this publisher couldn't be found, please try again later or go back to the publisher overview to browse more."
    },
    MY_PUBLISHERS: {
      TITLE: "My Publishers",
      INTRO:
        "Find an overview of the publishers that can promote your brand, webshop and products through the Impactbytes network.",
      ATTRIBUTION_PERIOD_TOOLTIP: "If a customer makes a purchase within the attribution period after entering your website through an affiliate link, the referring publisher receives credit for the sale.",
      COMMISSION_TOOLTIP: "The commission percentage the publisher receives of each of order placed by a customer referred through their affiliate link(s) within the attribution period."
    }
  },
  USER_ONBOARDING: {
    FORM: {
      BUTTON: "Continue",
      NAME: {
        LABEL: "What is your name?",
        PLACEHOLDER: "Enter your name...",
        REQUIRED: "Please enter your name"
      }
    }
  },
  PUBLISHER: {
    ONBOARDING: {
      PAGE_TITLE: "Onboarding",
      FORM: {
        BUTTON: "Continue",
        SUBMIT: "Submit",
        COMPANY: {
          LABEL: "Company name",
          REQUIRED: "Please enter your company name"
        },
        COMPANY_EMAIL: {
          LABEL: "Company e-mail (for notifications and invoices)",
          REQUIRED: "Please enter your company e-mail address"
        },
        LINK: {
          LABEL: "Website link",
          TOOLTIP:
            "A valid url looks like: exampe.com, www.exampe.com, https://example.com, example.com/about",
          REQUIRED:
            "Enter a link to your (company) website or one of your social accounts",
          VALID: "Enter a valid url"
        },
        DESCRIPTION: {
          LABEL: "Short description"
        }
      }
    },
    ANALYTICS: {
      PAGE_TITLE: "Analytics"
    },
    AFFILIATE_SETTINGS: {
      PAGE_TITLE: "Settings",
      PROFILE_TITLE: "Profile",
      AUDIENCE_TITLE: "Platform & Audience",
      FORM: {
        NOTIFICATIONS: {
          LABEL:
            "Receive an email notification when an order is made through an affiliate link"
        },
        LINK: {
          LABEL: "Website link",
          PLACEHOLDER: "https://example.com",
          TOOLTIP:
            "A valid url looks like: exampe.com, www.exampe.com, https://example.com, example.com/about"
        }
      }
    },
    INTEGRATIONS_SETTINGS: {
      PAGE_TITLE: "Integration settings",
      TITLE: "Integration settings"
    },
    PRODUCTS: {
      PAGE_TITLE: "Products"
    },
    PRODUCT_DETAIL: {
      PAGE_TITLE: "Product"
    },
    FAQ: {
      PAGE_TITLE: "FAQ"
    },
    FINANCE_SETTINGS: {
      TITLE: "Finance settings"
    },
    PAYMENTS: {
      TITLE: "Payments",
      STATUS_pending: "Pending",
      STATUS_paid: "Paid"
    }
  }
};
